import * as React from 'react'

import { Avatar } from '@factorialco/deprecated-design-system'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import buildUrl from 'modules/core/lib/buildUrl'
import accessGroups from 'modules/core/store/collections/accessGroups'
import users from 'modules/core/store/collections/users'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { EmployeeProfileButton } from 'modules/reviews/components/EmployeeProfileButton'
import Content from 'modules/reviews/components/Reviewees'
import { useReviewees } from 'modules/reviews/hooks/useReviewees'
import { RevieweesContext } from 'modules/reviews/lib/RevieweesContext'
import groups from 'modules/reviews/store/collections/groups'
import type Review from 'modules/reviews/store/models/v2/Review'

interface Props {
  review: Review
  userId: number
}

export default function Reviewees({ review, userId, children }: React.PropsWithChildren<Props>) {
  useAsyncData(() => Promise.all([groups.fetch(), accessGroups.fetch()]), [])
  const { loading, reviewees, fetchReviewees } = useReviewees(review)

  const user = users.find({
    id: userId,
  })

  if (!user) throw new Error(`Missing user with id: ${userId}`)
  return (
    <ResponsivePage.Body
      loading={loading}
      error={null}
      header={{
        illustrationComponent: (
          <Avatar size="s40" url={buildUrl(user.avatar)} label={user.fullName()} />
        ),
      }}
      widget={<EmployeeProfileButton user={user} />}
    >
      <RevieweesContext.Provider
        value={{
          loading,
          reviewees,
          fetchReviewees,
          reviewModel: review,
        }}
      >
        <Content user={user} />
        {children}
      </RevieweesContext.Provider>
    </ResponsivePage.Body>
  )
}
